import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import http from '@/config/httpConfig'
import store from "./store";
import axios from 'axios'
import '@/utils/dialogDrag'
import utils from "@/utils/utils";
import * as dialog from "@/utils/dialog";
// import $ from 'jquery'
import '@ztree/ztree_v3/js/jquery.ztree.core.js'
import '@ztree/ztree_v3/js/jquery.ztree.all.min.js'
import '@ztree/ztree_v3/css/zTreeStyle/zTreeStyle.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import './styles/main.less'
import './styles/ztree.less'
import './styles/table.less'

Vue.prototype.$ = $;
Vue.prototype.$ajax = axios
Vue.prototype.$utils = utils
Vue.prototype.$dialog = dialog
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VXETable)
//路由拦截，登陆失败跳转登录
router.beforeEach((to, from, next) => {
  // console.log(to)
  // console.log(from)
  // window.document.cookie = "HncToken=eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE3NzY0MzQxNDIsInN1YiI6IntcInZhbGlkaXR5UGVyaW9kXCI6MjU5MjAwMCxcInVpZFwiOlwiOGE5ZTIzMjk2ZTE3YmU0ZTAxNmUxYTY0N2Q0MzdkZDFcIixcImlzdXVlZEF0XCI6MTc3NjQzNDE0Mjg0MCxcIm5hbWVcIjpcIkNhc3NpZVwiLFwibG9naW5cIjpcIjE4ODEwNzc4Njg2XCJ9IiwiZXhwIjoxNzc5MDI2MTQyfQ.Et4wtEDihdlhOwB0yzHyatnTCAuKo48vnfLYoLOnF2g";
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requireAuth)) {
    let token = getCookie('HncToken')
    if (token && token.length > 0) {
      next()
    } else {
      if (to.path == '/' && to.query && to.query.HncToken) {
        token = to.query.HncToken
      }
      // router.push({
      //   path: 'ProxyLogin',
      //   query: {
      //     plan: 'private'
      //   }
      // })
      proxyLogin(to, from, token, next)
    }
  } else {
    next()
  }
});


function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}
function clearAllCookie() {
  var date = new Date();
  date.setTime(date.getTime() - 10000);
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  console.log("需要删除的cookie名字：" + keys);
  if (keys) {
    for (var i = keys.length; i--;)
      document.cookie = keys[i] + "=0; expire=" + date.toGMTString() + "; path=/";
  }
}
function proxyLogin(to, from, token,next) {
  let _this = this
  let returnURL = ''
  //解决地址栏输入影子系统地址，但是登录上去却是正式环境的系统
  if (to && to.query && to.query.returnURL) {
    returnURL = to.query.returnURL
  }
  http.get('/api/common/organizationstructure/user/proxylogin', true, { HncToken: token ? token : '', returnURL}, function (res) {
    console.log(res);
    let data = res.data.data
    $.getJSON(data.askurl + "?callback=?", {
        askData: data.askData,
        HncToken: token ? token : '',
        switchboard_identity_id: '',
        appDomain: data.appDomain,
      },
      function (d) {
        console.log(d)
        if (d.status == false) {
          if ("没有获取到token" == d.msg || "根据token没有获取用户信息" == d.msg) {
            
          } else {
            alert(d.msg);
          }
          clearAllCookie()
          window.location.href = data.redirectLoginUrl;
        } else {
          http.get('/api/common/organizationstructure/user/oklogin', false, {
            token: d.msg,
            HncToken: d.msg,
            switchboard_identity_id: d.obj,
            returnURL: data.returnURL
          }, function (res) {
            if (res.data.status) {
              next()
            } else {
              alert(res.msg);
              window.location.href = res.redirectLogoutUrl;
            }
          })
        }
      })
  })
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");















